import * as config from '../config.js';
import { init_datalayer, push_utag_data } from '../init.js';
import { PAGE_VARS } from '../../page/vars.js';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'datalayer_cart';

// Re-exports
export let global_vars = {};

// Datalayer values
export const CART = {
    age: [],
    brand: [],
    category: [],
    country: [],
    gender: [],
    id: [],
    list_name: [],
    list_position: [],
    name: [],
    original_price: [],
    price: [],
    quantity: [],
    sku: [],
    url: [],
    variant: [],
    set: [],
    type: [],

    impression_id: [],
    impression_name: [],
    impression_category: [],
    impression_variant: [],
    impression_price: [],
    impression_list_name: [],
    impression_position: [],

    promo_id: [],
    promo_name: [],
    promo_creative: [],
    promo_position: [],
};

// ===========================================================================
// Cart datalayer handlers
// ===========================================================================

function addon_handler(global) {
    let doc = global.document;
    let submit_buttons = doc.querySelectorAll('.basketCard-submit');

    // If there are no items in the cart, do nothing
    if (submit_buttons.length === 0) {
        return;
    }

    for (let i = 0; i < submit_buttons.length; i++) {
        const btn = submit_buttons[i];
        btn.addEventListener('click', () => {
            let dataset = btn.dataset;
            let cardnum = dataset.cardnum;
            let form = doc.getElementById(`form_id_${cardnum}`);
            let selector =
                '.js-validate > input[name="properties[productType]"]';
            let input_field = form.querySelector(selector);
            input_field.setAttribute('value', 'addon');
        });
    }
}

// ===========================================================================
// Data layer
// ===========================================================================

function update_data(global, utag_data, url, title) {
    let lang = global.document.querySelector('body').dataset.lang;

    // These were not in the new document, so we're keeping
    // them around in case they're still being used.
    utag_data['product_list'] = CART.list_name;
    utag_data['product_position'] = CART.list_position;
    utag_data['product_qty'] = CART.quantity;
    utag_data['product_sku'] = CART.sku;
    utag_data['product_type'] = CART.type;
    utag_data['page_url'] = url;
    utag_data['device_type'] = config.DEVICE.device;
    utag_data['language'] = `${lang}-CA`;

    // These carried over from the old code
    utag_data['product_age'] = CART.age;
    utag_data['product_brand'] = CART.brand;
    utag_data['product_category'] = CART.category;
    utag_data['product_country'] = CART.country;
    utag_data['product_gender'] = CART.gender;
    utag_data['product_id'] = CART.id;
    utag_data['product_name'] = CART.name;
    utag_data['product_variant'] = CART.variant;
    utag_data['product_price'] = CART.price;
    utag_data['product_set'] = CART.set;
    utag_data['page_name'] = title;
    utag_data['page_type'] = 'cart';

    //  NEW
    utag_data['impression_id'] = CART.impression_id;
    utag_data['impression_name'] = CART.impression_name;
    utag_data['impression_category'] = CART.impression_category;
    utag_data['impression_variant'] = CART.impression_variant;
    utag_data['impression_price'] = CART.impression_price;
    utag_data['impression_list'] = CART.impression_list_name;
    utag_data['impression_position'] = CART.impression_position;
    utag_data['enh_checkout_step'] = 1;
    utag_data['enh_action'] = PAGE_VARS.action;

    push_utag_data(utag_data);
}

function init_handlers(global) {
    addon_handler(global);
}

// global is the window object when in the browser context this function should
export function initialize(global) {
    init_datalayer(global, init_handlers, update_data);
}

// ===========================================================================
//
// ===========================================================================
